import { combineReducers } from "redux";

import { default as newDataReport } from "./new-data-report";
import { default as dataReportList } from "./data-report-list";

export default combineReducers({ newDataReport, dataReportList });

export * from "./new-data-report";
export * from "./data-report-list";
